module.exports = __webpack_public_path__ + "static/media/bg-opening31021825f819e099d310a3b478c410c4.webp";